import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import { fetchSharedSchedules } from "redux/actions/flowDesigner/calendarActionCreator";

const useSharedSchedules = () => {
  const { sharedSchedules, calendarEvents } = useSelector((store) => store?.designer?.calendar);
  const { user } = useAuth0();
  const dispatch = useDispatch();
  const [userSharedSchedules, setUserSharedSchedules] = useState([]);

  const reloadSharedSchedules = () => {
    if (!user) return;
    dispatch(fetchSharedSchedules(user.stripeId, user.cxfUserId));
  };

  useEffect(() => {
    if (!user) return;
    dispatch(fetchSharedSchedules(user.stripeId, user.cxfUserId));
  }, [user]);

  useEffect(() => {
    if (sharedSchedules?.length) {
      const events = calendarEvents?.filter((event) => event.shared_user_id === user.cxfUserId);
      setUserSharedSchedules(events);
    }
  }, [sharedSchedules]);

  return {
    sharedSchedules,
    calendarEvents,
    reloadSharedSchedules,
    userSharedSchedules,
  };
};

export default useSharedSchedules;
